import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control} from 'react-redux-form';

class CustomCheckbox extends Component {
	render() {
		const {model, label, value, ...rest} = this.props;

		return (
			<div className="checkbox">
				<label>
					<Control.checkbox model={`.${model}`} value={value} {...rest}/>
					{label}
				</label>
			</div>
		)
	}
}

CustomCheckbox.defaultProps = {
	value: true
};

CustomCheckbox.propTypes = {
	model: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool
	])
};

export default CustomCheckbox;